import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';

type MinorAlarmFields = Pick<UnifiedAlarm, 'severity' | 'resolvedAlarm'>;

/**
 * Whether an alarm counts as minor in the alarm group view (chips, compressed
 * timeline, hide-minors toggle, timeline colours).
 *
 * Every source sets only one of the two signals: v2 scan events carry a
 * severity and always have `resolvedAlarm: false`, while the location-alarm
 * path (LA page transform, event-flow) never sets severity ('') and marks
 * minors with `resolvedAlarm`. v3 delivers scan-shaped data through that path,
 * and its minors only reach the UI since ai-engine #8071.
 */
export const isMinorAlarm = (alarm: MinorAlarmFields): boolean =>
  alarm.severity === 'low' || alarm.resolvedAlarm;
